export enum MANAGEPASSWORDSTEPS {
  ACTIVATION = 1,
  OTP,
  PIN,
  MANAGE,
  setBiometric,
}
